// fill="${color ? color : "currentColor"}"
// width=${width}
// height=${height}
// currentColor ใส่เเทนสี ที่ต้องการเปลี่ยน สีตาม  ConfigProvider theme
import PropTypes from 'prop-types'

import React from 'react'

const Index = ({ width = 16, height = 16 }) => {
  const svgXml = `

        <svg width=${width} height=${height} viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" width="40" height="40" rx="8" fill="#13BBC4"/>
<path d="M30.2969 15.546L18.2969 27.546C18.1924 27.6509 18.0682 27.7341 17.9314 27.7909C17.7947 27.8476 17.6481 27.8769 17.5 27.8769C17.3519 27.8769 17.2053 27.8476 17.0686 27.7909C16.9318 27.7341 16.8076 27.6509 16.7031 27.546L11.4531 22.296C11.3485 22.1913 11.2655 22.0671 11.2088 21.9304C11.1522 21.7936 11.123 21.6471 11.123 21.4991C11.123 21.3511 11.1522 21.2046 11.2088 21.0678C11.2655 20.9311 11.3485 20.8069 11.4531 20.7022C11.5578 20.5976 11.682 20.5146 11.8187 20.4579C11.9555 20.4013 12.102 20.3721 12.25 20.3721C12.398 20.3721 12.5445 20.4013 12.6813 20.4579C12.818 20.5146 12.9422 20.5976 13.0469 20.7022L17.5009 25.1563L28.705 13.9541C28.9163 13.7428 29.203 13.624 29.5019 13.624C29.8008 13.624 30.0874 13.7428 30.2987 13.9541C30.5101 14.1654 30.6288 14.4521 30.6288 14.751C30.6288 15.0499 30.5101 15.3365 30.2987 15.5479L30.2969 15.546Z" fill="white"/>
</svg>

  `

  return (
    <div
      style={{ display: 'flex', alignItems: 'center' }}
      dangerouslySetInnerHTML={{ __html: svgXml }}
    />
  )
}
Index.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}
export default Index
